import React from "react";
/**
 * Flex grow component. May contain children that occupies space, or no children to space surrounding components.
 */
const Grow = ({ weight = 1, children, }) => {
    return (React.createElement("div", { className: "aui-grow", style: { flexGrow: weight } }, children));
};
export default Grow;
